<template>
    <div class="container-fluid justify-content-center">

        <div v-if="successMessage">
            <b-alert show dismissible fade variant="success" class="welcome_message">
                <h4 class="alert-heading">Enjoy InboxGPT 🥳</h4>
                <p>Thanks for getting InboxGPT. We are cheerful to see you take the next step in customer communication.</p>
            </b-alert>
        </div>

        <div v-if="failedMessage">
            <b-alert show dismissible fade variant="warning" class="welcome_message">
                <h4 class="alert-heading">Not completed</h4>
                <p>Your sign-up for InboxGPT failed or was canceled. Please try again.</p>
                <hr>
                <p class="mb-0">
                    👉 If you have any questions or need support, we are happy to help! <a class="boei-embed-open">Contact us</a>.
                </p>
            </b-alert>
        </div>

        <div v-if="loading" class="text-center">
            <b-spinner></b-spinner>
        </div>
        <template v-else>
            <div v-if="!upgradeOnly && account.is_subscribed">
                <div class="card card-default">

                    <div class="card-header">Account</div>

                    <div class="card-body" v-if="manageSeats">
                        <b-form-group id="num_users" label="Number of seats" label-for="ai_styleSelect">
                            <validation-provider name="Number of seats" rules="required" v-slot="{ errors }">
                                <b-form-select id="quantity" v-model="quantity">
                                    <option v-for="value in 100" :key="value" :value="value">{{ value }}</option>
                                </b-form-select>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <p>We will charge extra seats based on the number of days left for the month.</p>

                        <b-button type="submit" variant="primary" @click="updateSeats">Update seats</b-button>
                    </div>
                    <div class="card-body" v-else>
                        <div v-if="loading"><img src="/loading.svg"> Loading...</div>
                        <div v-else>

                            <p>Your subscription is active 🎉 You have {{account.quantity}} seat(s).</p>

                            <b-button type="outline" class="mr-2" @click="manageSeats = true">Update seats</b-button>
                            <a :href="account.update_url" class="btn btn-outline mr-2" target="_blank">Adjust payment method</a>
                            <a :href="account.cancel_url" class="btn btn-outline" target="_blank">Cancel</a>

                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!account.is_subscribed && !loading" class="card card-default">
                <div class="card-header border-0 text-center pb-0">Start your free trial</div>

                <div class="card-body">
                    <div class="mx-auto" style="max-width: 500px;">
                        <div class="card">
                            <div class="card-body small text-center">
                                <h4 class="text-secondary mb-2">Growth</h4>
                                <p>For businesses and teams that need to quickly gain control over message overload</p>
                                <h5 class="mt-4 mb-0"><small>&dollar;</small> 29 <small>/user/mo</small></h5>

                                Unified AI Powered Mailboxes<br>
                                Unlimited messages<br>
                                Team collaboration on messages<br>
                            </div>
                        </div>

                        <b-form-group id="num_users" label="Number of users" label-for="ai_styleSelect">
                            <validation-provider name="Number of users" rules="required" v-slot="{ errors }">
                                <b-form-select id="quantity" v-model="quantity">
                                    <option v-for="value in 100" :key="value" :value="value">{{ value }}</option>
                                </b-form-select>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <p class="text-center"><small>&dollar;</small> {{ quantity * 29 }} <small>/month</small></p>

                        <b-button type="submit" variant="primary" @click="openCheckout" class="btn-block">Start 7 day trial</b-button>
                    </div>
                </div>

            </div>
        </template>
    </div>
</template>

<script>
    import { StripeCheckout } from 'vue-stripe-checkout';
    import NotificationPop from '../mixins/NotificationPop.js'

    export default {
        mounted() {
            console.log(this.paddleVendorId)
            this.loadScript().then(() => {
                if(this.paddleSandbox) {
                    Paddle.Environment.set('sandbox');
                }
                Paddle.Setup({ vendor: this.paddleVendorId });
            });
        },
        mixins: [NotificationPop],
        data: () => ({
            // generic
            account: {
            },
            manageSeats: false,

            upgradeOnly: false,
            quantity: 1,

            loading: true,

            successMessage: null,
            failedMessage: null,

            paddleProductId: parseInt(process.env.MIX_PADDLE_PRODUCT_ID),
            paddleVendorId: parseInt(process.env.MIX_PADDLE_VENDOR_ID),
            paddleSandbox: JSON.parse(process.env.MIX_PADDLE_SANDBOX), // parse as bool
        }),
        async created() {
            // Fetch team data from API
            this.$http.get(`team/account`)
                .then(response => {
                    this.account = response.data;
                    this.quantity = this.account.quantity ?? 1
                    this.loading = false
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    // Hide the loading spinner

                });

            if('subscription_success' in this.$route.query) {
                this.successMessage = true

                // Tracking new subscriber
                // this.$gtm.trackEvent({
                //     event: 'subscribe',
                //     email: this.$auth.user().name,
                // });

                // Show confetti
                this.$confetti.start({
                    particles: [
                        {
                            type: 'heart',
                            size: 14,
                        }
                    ],
                });
                setTimeout(() => this.$confetti.stop(), 2000);

            }

            if('subscription_failed' in this.$route.query) {
                this.failedMessage = true
            }

            if('upgrade' in this.$route.query) {
                this.upgradeOnly = true
            }
        },
        methods: {
            loadScript() {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = 'https://cdn.paddle.com/paddle/paddle.js';
                    script.async = true;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            },
            openCheckout() {
                Paddle.Checkout.open({
                    product: this.paddleProductId, // plan id: 52541 (in ENV)
                    email: this.$auth.user().email,
                    quantity: this.quantity,
                    passthrough: '{"team_id": '+this.$auth.user().team_id+'}',
                    success: 'https://app.inboxgpt.ai/account?subscription_success',
                });
            },
            updateSeats() {
                this.loading = true

                this.$http
                    .post('team/account/update_seats', {
                        team_id: this.$auth.user().team_id,
                        quantity: this.quantity
                    })
                    .then(response => {
                        this.manageSeats = false
                        this.loading = false
                        this.popNotification('Updated seats successfully', 'success')
                    })
                    .catch(error => {
                        this.loading = false
                        this.popNotification('Cannot update seats. Please contact support', 'danger')
                        console.error('Error saving settings', error);
                    });
            },
        }
    }
</script>
